'use client'

import { SWRConfig } from 'swr'
import type { ReactNode } from 'react'
import type { SWRConfiguration } from 'swr'
import { swrConfig } from '@/lib/swr-config'

interface SWRProviderProps {
	children: ReactNode
	fallback?: SWRConfiguration['fallback']
}

export default function SWRProvider({ children, fallback }: SWRProviderProps) {
	return (
		<SWRConfig value={{ ...swrConfig, fallback }}>
			{children}
		</SWRConfig>
	)
}
